module.exports = __webpack_public_path__ + "img/CS48Q-中_11.af2395a8.jpg";